// Imperative bridge to the navbar's product search field, so the `/` shortcut
// and the command palette can expand+focus it without reaching into the navbar.
let api: { focus(): void } | null = null;

export function registerProductSearch(instance: { focus(): void }) {
  api = instance;
}

export function unregisterProductSearch() {
  api = null;
}

export function focusProductSearch() {
  api?.focus();
}
